import React, { useEffect } from "react";
import Layout from "../../components/layout";
import bluebox from "../../images/bluebox-2.png";
import blueboxStep from "../../images/bluebox-step.png";
import userstory from "../../images/user-story.png";
import userstoryVertical from "../../images/user-story_vertical.png";

const BlueBox = () => {
  const [viewWidth, setViewWidth] = React.useState(undefined);
  const breakpoint = 900;

  useEffect(() => {
    window.addEventListener('resize', () => setViewWidth(window.innerWidth));
  });

  return (
    <Layout>
      <div className="product">
        <section className="product-title">
          <div className="product-title__container">
            <h1 className="heading-primary u-margin-bottom-small">
              <span className="heading-primary--main">BlueBox</span>
            </h1>
          </div>
        </section>
        <section className="product-content">
          <div className="row u-margin-bottom-small">
            <h2 className="heading-secondary product-content__title">
              What is a BlueBox?
            </h2>
          </div>
          <div className="row">
            <p className="paragraph">
              Medical practice and aviation have much in common. Both have high risks and are subject to human errors. After an airplane crash, investigators rely on the cockpit data recorder-- the “black box”, to understand the causes of the accident or failure, so that future events can be prevented.  BlueBox is a code blue recorder and electronic code sheet that can serve the important function of full-disclosure recording of code blue events to support post-CPR debriefing and quality improvement review.  We are working on the next version of BlueBox that can provide real-time feedback on CPR performance for instantaneous improvement in quality and outcomes.
            </p>
          </div>
          <div className="row">
            <div className="col-1-of-3 product-img u-margin-right-zero">
              <img src={bluebox} alt="bluebox" className="product-img__xl" />
            </div>
            <div className="col-2-of-3">
              <p className="paragraph">
                The BlueBox is a 8 x 4 x 1.5 cm solid recorder comes with a
                disposable electrode patch shaped like a big Band-Aid. It is
                placed on the left chest next to the sternum at the 4th
                intercostal space (at the level between the two nipples). This
                placement will maximize the capture of important CPR data,
                without hindering chest compression, defibrillation, and
                procedures. The user will verbally announce the identifiers of
                the patient being resuscitated (name, medical record number,
                etc.). The device is completely sealed and splash proof. There
                is an automatic magnetic switch that turns the recorder on when
                the release liner is removed. The device is designed to prevent
                unauthorized removal of the internal memory or other tampering.
                It also allows authorized personnel to access and erase the
                data.
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-2-of-3  u-margin-right-zero" style={{alignSelf: 'flex-end'}}>
              <p className="paragraph">
              The BlueBox system and electronic code sheet can serve 3 important functions:
                <ol type="1">
                  <li>Full-disclosure recording of code blue events to support post-CPR debriefing and quality improvement review</li>
                  <li>Full-disclosure recording of code blue events for medico-legal documentation and EMR integration</li>
                  <li>Real-time feedback on CPR performance for instantaneous improvement in quality and outcomes</li>
                </ol>
              </p>
            </div>
            <div className="col-1-of-3 product-img">
              <img src={blueboxStep} alt="placement" className="product-img__xxl" />
            </div>
          </div>
          <div className="row ">
            <div className="col-1-of-4"></div>
            <div className="col-2-of-4 youtube-video__wrapper youtube-video__wrapper-lg">
              <iframe width="560" height="100%" src="https://www.youtube.com/embed/rOtP70tm17U" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            </div>
            <div className="col-1-of-4"></div>
          </div>
          {/* <div className="row youtube-video__wrapper">
            <iframe width="560" height="100%" src="https://www.youtube.com/embed/rOtP70tm17U" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
          </div> */}
          <div className="row u-margin-bottom-small u-center-text">
            <h2 className="heading-secondary product-content__title">
              How to use
            </h2>
          </div>
          <div className="row">
            <img src={viewWidth <= breakpoint ? userstoryVertical : userstory} alt="bluebox" className="product-img__full" />
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default BlueBox;
